const PodcastDescription = () => {
  return (
    <div>
      <h2 className="text-[#001A3D] font-['DM_Sans'] text-base lg:text-lg lg:pb-6 font-medium leading-5 tracking-wide pl-4 lg:!pl-0">
        Our conversations on legal life events
      </h2>

      <div className='pl-6 lg:pl-0'>
        <p className="text-[#25395C] font-['DM_Sans'] text-sm leading-6 tracking-wide mt-4 font-normal lg:font-medium">
          Unlock a wealth of legal knowledge by diving into our exclusive
          collection of blogs and articles, authored by seasoned attorneys.
          Whether you're seeking insights on the latest legal trends or guidance
          on complex issues, our platform offers you direct access to the
          expertise of top legal professionals.
        </p>

        <p className="text-[#25395C] font-['DM_Sans'] text-sm leading-6 tracking-wide mt-4 font-normal lg:font-medium">
          Start exploring now to stay informed and make well-informed decisions
          for your legal needs.
        </p>

        <div className='mt-6 mb-6 flex justify-end lg:justify-start'>
          <a
            href='/podcasts'
            className='inline-flex justify-center rounded-md text-sm text-light !py-2 px-4 shadow-md'
          >
            Show more
          </a>
        </div>
      </div>
    </div>
  )
}

export default PodcastDescription
